var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdvancedSettings = function SvgIconAdvancedSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 26.22,
    y1: 455.3,
    x2: 366.42,
    y2: 85.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 149.01,
    y1: 568.33,
    x2: 489.21,
    y2: 198.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -115.21,
    y1: 325.1,
    x2: 224.98,
    y2: -44.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -112,
    y1: 328.06,
    x2: 228.2,
    y2: -41.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -52.93,
    y1: 382.43,
    x2: 287.27,
    y2: 12.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -49.71,
    y1: 385.4,
    x2: 290.49,
    y2: 15.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 9.36,
    y1: 439.77,
    x2: 349.55,
    y2: 70.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 12.55,
    y1: 442.71,
    x2: 352.74,
    y2: 73.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -13.08,
    y1: 419.12,
    x2: 327.11,
    y2: 49.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -48.16,
    y1: 386.82,
    x2: 292.03,
    y2: 17.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -66.6,
    y1: 369.85,
    x2: 273.6,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 15.99,
    y1: 445.87,
    x2: 356.18,
    y2: 76.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 10.72,
    y1: 441.03,
    x2: 350.91,
    y2: 71.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 21.33,
    y1: 450.79,
    x2: 361.52,
    y2: 81.24,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M492.5,322.96l-12.92-8.54-12.79-30.88,3.1-15.19c1.12-5.48-.58-11.17-4.54-15.12l-18.58-18.58c-3.96-3.95-9.64-5.66-15.12-4.53l-15.18,3.11-30.89-12.8-8.55-12.92c-3.08-4.68-8.3-7.49-13.9-7.5h-4.8v-108.33c0-.18-.09-.33-.1-.52-.05-.75-.2-1.49-.45-2.2-.09-.27-.16-.53-.28-.78-.39-.88-.94-1.68-1.61-2.38L272.57,2.46c-.7-.68-1.52-1.23-2.41-1.62-.25-.11-.5-.2-.75-.28-.73-.26-1.49-.41-2.27-.45-.16-.04-.31-.08-.47-.11H25C11.19,0,0,11.19,0,25v391.67c0,13.81,11.19,25,25,25h206.29c.78,1.9,1.91,3.63,3.33,5.12l18.56,18.56c3.95,3.97,9.64,5.68,15.13,4.55l15.19-3.11,30.91,12.8,8.55,12.92c3.08,4.68,8.3,7.49,13.9,7.5h26.27c5.6,0,10.83-2.82,13.91-7.5l8.54-12.92,30.89-12.8,15.18,3.11c5.48,1.12,11.17-.58,15.12-4.54l18.57-18.57c3.96-3.96,5.66-9.64,4.54-15.12l-3.1-15.19,12.79-30.88,12.92-8.55c4.68-3.08,7.49-8.3,7.5-13.9v-26.27c0-5.6-2.82-10.83-7.5-13.91ZM275,28.45l54.88,54.88h-46.55c-4.6,0-8.33-3.73-8.33-8.33V28.45ZM231.47,425H25c-4.6,0-8.33-3.73-8.33-8.33h0V25c0-4.6,3.73-8.33,8.33-8.33h233.33v58.33c0,13.81,11.19,25,25,25h58.33v100h-4.8c-5.6,0-10.83,2.82-13.91,7.5l-8.54,12.92-30.88,12.8-15.2-3.11c-5.49-1.14-11.18.57-15.12,4.54l-18.56,18.56c-3.96,3.96-5.67,9.64-4.55,15.13l3.11,15.19-12.79,30.88-12.92,8.55c-4.68,3.08-7.49,8.3-7.5,13.9v26.27c0,5.6,2.82,10.83,7.5,13.91l12.92,8.54,12.8,30.88-1.74,8.53ZM468.26,373.08c-1.39.92-2.47,2.22-3.11,3.76l-14.74,35.61c-.64,1.54-.8,3.23-.47,4.86l3.62,17.69-18.57,18.57-17.68-3.62c-1.63-.34-3.32-.18-4.86.46l-35.61,14.75c-1.54.64-2.84,1.72-3.76,3.11l-9.96,15.07h-26.27l-9.95-15.07c-.92-1.39-2.22-2.47-3.76-3.11l-35.61-14.75c-1.01-.42-2.09-.63-3.18-.63-.56,0-1.12.06-1.67.17l-17.69,3.62-18.58-18.57,3.62-17.69c.33-1.63.18-3.32-.46-4.86l-14.75-35.61c-.64-1.54-1.72-2.84-3.11-3.76l-15.07-9.95v-26.27l15.07-9.95c1.39-.92,2.47-2.22,3.11-3.76l14.75-35.61c.63-1.54.79-3.23.46-4.86l-3.62-17.69,18.57-18.57,17.69,3.62c1.63.34,3.32.18,4.86-.46l35.61-14.75c1.54-.64,2.84-1.72,3.76-3.11l9.95-15.07h26.27l9.95,15.07c.92,1.39,2.22,2.47,3.76,3.11l35.61,14.75c1.54.64,3.23.8,4.86.46l17.69-3.62,18.57,18.57-3.62,17.69c-.33,1.63-.17,3.32.47,4.86l14.74,35.61c.64,1.54,1.72,2.84,3.11,3.76l15.07,9.95v26.27h0l-15.07,9.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350,258.33c-50.63,0-91.67,41.04-91.67,91.67s41.04,91.67,91.67,91.67,91.67-41.04,91.67-91.67c-.06-50.6-41.07-91.61-91.67-91.67ZM350,425c-41.42,0-75-33.58-75-75s33.58-75,75-75,75,33.58,75,75c-.05,41.4-33.6,74.95-75,75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.67,150h58.33c13.81,0,25-11.19,25-25v-8.5c0-4.6-3.73-8.33-8.33-8.33s-8.33,3.73-8.33,8.33v8.5c0,4.6-3.73,8.33-8.33,8.33h-58.33c-4.6,0-8.33-3.73-8.33-8.33v-58.33c0-4.6,3.73-8.33,8.33-8.33h50.17c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-50.17c-13.81,0-25,11.19-25,25v58.33c0,13.81,11.19,25,25,25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.23,50.26c-2.89-.98-6.09-.3-8.33,1.77v-.02s-52.49,45-52.49,45l-11.21-11.21c-3.27-3.16-8.47-3.11-11.68.1-3.21,3.21-3.26,8.41-.1,11.68l16.67,16.67c3.08,3.08,8.01,3.27,11.32.43l58.33-50c2.39-1.9,3.55-4.95,3.03-7.96-.52-3.01-2.65-5.49-5.54-6.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.67,275h58.33c13.81,0,25-11.19,25-25v-8.5c0-4.6-3.73-8.33-8.33-8.33s-8.33,3.73-8.33,8.33v8.5c0,4.6-3.73,8.33-8.33,8.33h-58.33c-4.6,0-8.33-3.73-8.33-8.33v-58.33c0-4.6,3.73-8.33,8.33-8.33h50.17c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-50.17c-13.81,0-25,11.19-25,25v58.33c0,13.81,11.19,25,25,25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M161.23,175.26c-2.89-.98-6.09-.3-8.33,1.77v-.03s-52.49,45-52.49,45l-11.21-11.21c-3.27-3.16-8.47-3.11-11.68.1-3.21,3.21-3.26,8.41-.1,11.68l16.67,16.67c3.08,3.08,8.01,3.27,11.32.43l58.33-50c2.39-1.9,3.55-4.95,3.03-7.96-.52-3.01-2.65-5.49-5.54-6.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M141.67,358.17c-4.6,0-8.33,3.73-8.33,8.33v8.5c0,4.6-3.73,8.33-8.33,8.33h-58.33c-4.6,0-8.33-3.73-8.33-8.33v-58.33c0-4.6,3.73-8.33,8.33-8.33h50.17c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-50.17c-13.81,0-25,11.19-25,25v58.33c0,13.81,11.19,25,25,25h58.33c13.81,0,25-11.19,25-25v-8.5c0-4.6-3.73-8.33-8.33-8.33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.9,302.04v-.03s-52.49,45-52.49,45l-11.21-11.21c-3.27-3.16-8.47-3.11-11.68.1-3.21,3.21-3.26,8.41-.1,11.68l16.67,16.67c3.08,3.08,8.01,3.27,11.32.43l58.33-50c3.29-3.04,3.59-8.14.67-11.54-2.91-3.4-8-3.89-11.51-1.11Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191.67,141.67h116.67c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-116.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.67,108.33h48.42c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-48.42c-4.6,0-8.33,3.73-8.33,8.33,0,4.6,3.73,8.33,8.33,8.33Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M191.67,75h41.67c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-41.67c-4.6,0-8.33,3.73-8.33,8.33,0,4.6,3.73,8.33,8.33,8.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.67,200h116.67c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-116.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.67,233.33h35.83c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-35.83c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M213.67,258.33c0-4.6-3.73-8.33-8.33-8.33h-13.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h13.67c4.6,0,8.33-3.73,8.33-8.33Z"
  })));
};
export default SvgIconAdvancedSettings;